import React, { useEffect, useRef, useState } from "react";
import { useLocation } from 'react-router-dom';
import { clearAll, createGameRequest, deleteGameRequest, getAnchorCategoriesRequest, getGameRequest, getGamesRequest, releaseGameAnswerGameRequest, updateGameRequest } from '../../redux/actions/getGameManagement';
import { getShowRequest } from '../../redux/actions/getShows';
import { connect } from "react-redux";
import { GameCssStyles } from "../../components/GameManagement/GameCssStyles";
import GameContainer from "../../components/GameManagement/GameContainer";
import { update } from "lodash";
import { GAME_TYPE } from "../../components/GameManagement/GameConstant";
import { useNavigate } from 'react-router-dom';

const fantasyReult = { "resultDate": "2025-07-14T08:14:46.234Z", "data": [{ "optionId": "6874c1062fb858e7ee3848ed", "entertainmentEntityId": "DAqfLDoy57gHa1FtOcshZ", "rank": 1 }, { "optionId": "6874c1062fb858e7ee3848ee", "entertainmentEntityId": "DAqfLDoy57gHa1FtOcshX", "rank": 2 }] }
const dummyFantasyResp = { "_id": "6874c1062fb858e7ee3848f3", "status": "active", "type": "fantasyLeague", "forkContestRules": [{ "ruleId": "6874c1062fb858e7ee3848f2", "contestType": "Practice", "isPromoted": false, "maxSpots": 3, "minSpots": 2, "fantasyPickCount": 1, "ticketPrice": { "money": { "value": 0, "currency": "inr" } }, "questionSource": { "type": "question", "details": { "questionId": "6874c1062fb858e7ee3848ec" } }, "win": { "prizePoolShare": 1, "winPositions": [{ "position": 1, "share": 1 }] } }], "banner": "https://fastly.picsum.photos/id/17/400/100.jpg?hmac=EY9k-fT6I_0Z9CwXLQmvc_cZbQksLGHqiddNyaMAYQ0", "title": "TItle F", "subTitle": "Subtitle", "rules": { "aboutGame": "About Game", "sourceOfTruth": "Source Of Truth", "rules": "Contest Rules", "goLiveAt": 1753403400000, "submissionCutOffAt": 1753489800000, "resultDeclarationAt": 1753576200000, "sourceOfTruthUrl": "https://www.google.com", "termsConditionsUrl": "https://www.google.com" }, "anchor": { "type": "show", "id": "68638e804e60115ecb26a6a1", "index": 0, "hierarchy": [] }, "created_at": "2025-07-14T08:34:14.772Z", "updated_at": "2025-07-14T08:34:14.772Z", "__v": 0, "question": { "_id": "6874c1062fb858e7ee3848ec", "gameType": "fantasyLeague", "questionText": "Ques1", "status": "in-review", "multimedia": { "mediaType": "", "url": "", "aspectRatio": "" }, "options": [{ "text": "Answ1", "label": "A", "entertainmentEntityId": "DAqfLDoy57gHa1FtOcshZ", "multimedia": { "mediaType": "image", "url": "https://fastly.picsum.photos/id/441/200/300.jpg?blur=5&hmac=c-DAqfLDoy57gHa1FtOcshZ-4IewbN5DgOULnxT0thE", "aspectRatio": "1:1" }, "_id": "6874c1062fb858e7ee3848ed" }, { "text": "Answ2", "label": "B", "entertainmentEntityId": "DAqfLDoy57gHa1FtOcshX", "multimedia": { "mediaType": "image", "url": "https://fastly.picsum.photos/id/441/200/300.jpg?blur=5&hmac=c-DAqfLDoy57gHa1FtOcshZ-4IewbN5DgOULnxT0thE", "aspectRatio": "1:1" }, "_id": "6874c1062fb858e7ee3848ee" }, { "text": "Answ3", "label": "C", "entertainmentEntityId": "TmmQSbShHz9CdQm0NkEjx1Dyh", "multimedia": { "mediaType": "image", "url": "https://fastly.picsum.photos/id/237/200/300.jpg?hmac=TmmQSbShHz9CdQm0NkEjx1Dyh_Y984R9LpNrpvH2D_U", "aspectRatio": "1:1" }, "_id": "6874c1062fb858e7ee3848ef" }, { "text": "Answ4", "label": "D", "entertainmentEntityId": "QPKhNReQFJilT6PFUwm33", "multimedia": { "mediaType": "image", "url": "https://fastly.picsum.photos/id/476/200/200.jpg?hmac=QPKhNReQFJilT6PFUwm33_xa1DiivT32FbsWYE4evPU", "aspectRatio": "1:1" }, "_id": "6874c1062fb858e7ee3848f0" }], "created_at": "2025-07-14T08:34:14.739Z", "updated_at": "2025-07-14T08:34:14.739Z", "__v": 0 } }
const dummyGameData = {
  "_id": "68b029060fd63c53643b1365",
  "status": "active",
  "type": "FLReal",
  "entities": [
    "687a15b8bbe2ef85e9825991",
    "6891d3fdab78dae7a5f5b6e3",
    "68933ab23bc9140733a764a4",
    "687a162dd60e4bbf1742ae2b",
    "687a1793bb55b0248c4117cd",
    "687a1793bb55b0248c4117ce",
    "6890955131f40a8148e58b83",
    "6891d5920ad9f6069e94d685"
  ],
  "forkContestRules": [
    {
      "contestType": "Paid",
      "isPromoted": false,
      "maxSpots": 5,
      "minSpots": 2,
      "ticketPrice": {
        "money": {
          "value": 100,
          "currency": "inr"
        }
      },
      "win": {
        "prizePoolShare": 0.9,
        "winPositions": [
          {
            "position": 1,
            "share": 0.2
          },
          {
            "position": 2,
            "share": 0.8
          }
        ]
      },
      "ruleId": "68b029060fd63c53643b1366"
    }
  ],
  "banner": "https://example.com/banner.jpg",
  "title": "Youtube Weekly Top 10",
  "subTitle": "Retro Music",
  "rules": {
    "aboutGame": "Test your knowledge of retro music in a fast-paced challenge!",
    "sourceOfTruth": "All answers are verified from official sources.",
    "rules": "Answer quickly and correctly to win!",
    "goLiveAt": 1755435991000,
    "submissionCutOffAt": 1755435991001,
    "resultDeclarationAt": 1755435991002,
    "sourceOfTruthUrl": "https://example.com/source",
    "termsConditionsUrl": "https://example.com/terms"
  },
  "created_at": "2025-08-28T10:01:42.389Z",
  "updated_at": "2025-08-28T10:01:42.389Z",
  "__v": 0,
  "entityDetails": [
    {
      "_id": "687a15b8bbe2ef85e9825991",
      "type": "movie",
      "displayName": "The Lost Journey",
      "multimedia": [
        {
          "mediaType": "image",
          "imageType": "thumbnail",
          "url": "https://image-bucket-nexiantian.s3.ap-south-1.amazonaws.com/actor+photo/asha.png",
          "aspectRatio": "16:9"
        }
      ],
      "tags": [
        {
          "type": "song_genre",
          "details": {
            "songGenreName": "romantic",
            "id": ""
          }
        }
      ],
      "metadata": {
        "Year": "1975",
        "Released": "15Aug1975",
        "Plot": "",
        "Language": "Hindi",
        "Country": "India",
        "artists": [

        ]
      }
    },
    {
      "_id": "6891d3fdab78dae7a5f5b6e3",
      "type": "movie",
      "displayName": "Dilwale Versatile",
      "multimedia": [
        {
          "mediaType": "video",
          "imageType": "",
          "url": "https://api.vimeo.com/videos/1106363236",
          "aspectRatio": "16:9"
        },
        {
          "mediaType": "thumbnail",
          "imageType": "thumbnail",
          "url": "https://cdn-share-sprites.flaticon.com/pack/1/1384/1384020-social-media_3x2.jpg",
          "aspectRatio": "4:3"
        }
      ],
      "tags": [
        {
          "type": "genre",
          "details": {
            "genreName": "Drama",
            "_id": "64f3c9e2d1a3e2b1b8e5e9a1"
          }
        },
        {
          "type": "genre",
          "details": {
            "genreName": "Action",
            "_id": "64f3c9e2d1a3e2b1b8e5e9a2"
          }
        }
      ],
      "metadata": {
        "year": 2023,
        "duration": 150,
        "label": "T-Series",
        "language": "Hindi",
        "country": "India",
        "artists": [
          "64f3c8f0e1d2f0b6a4a8b012",
          "64f3c8f0e1d2f0b6a4a8b013"
        ],
        "artistType": "Lead Actor",
        "isSuperStar": true,
        "industry": [
          "Bollywood",
          "Indian Cinema"
        ]
      },
      "created_at": "2025-08-05T09:50:53.510Z",
      "updated_at": "2025-08-05T09:50:53.510Z"
    },
    {
      "_id": "68933ab23bc9140733a764a4",
      "type": "movie",
      "displayName": "Andaaz Apna Apna",
      "tags": [
        {
          "type": "movie_genre",
          "details": {
            "genreName": "social"
          }
        }
      ],
      "metadata": {
        "year": 1994,
        "duration": 228,
        "language": "hi",
        "country": "in",
        "artists": [

        ],
        "artistType": "actor",
        "industry": [
          "bollywood"
        ]
      },
      "multimedia": [

      ],
      "created_at": "2025-08-06T11:21:22.390Z",
      "updated_at": "2025-08-06T11:21:22.390Z",
      "__v": 0
    },
    {
      "_id": "687a162dd60e4bbf1742ae2b",
      "type": "song",
      "displayName": "WavesofSilence",
      "multimedia": [
        {
          "mediaType": "image",
          "imageType": "thumbnail",
          "url": "https://image-bucket-nexiantian.s3.ap-south-1.amazonaws.com/actor+photo/gulam.png",
          "aspectRatio": "16: 9"
        }
      ],
      "tags": [
        {
          "type": "song_genre",
          "details": {
            "genreName": "action",
            "id": ""
          }
        }
      ],
      "metadata": {
        "year": "2024",
        "duration": 228,
        "label": "SaReGaMAIndiaLtd",
        "language": "hindi",
        "country": "India",
        "artists": [

        ]
      }
    },
    {
      "_id": "687a1793bb55b0248c4117cd",
      "type": "song",
      "displayName": "EchoDream",
      "multimedia": [
        {
          "mediaType": "image",
          "imageType": "thumbnail",
          "url": "https://image-bucket-nexiantian.s3.ap-south-1.amazonaws.com/actor+photo/jaggeet.png",
          "aspectRatio": "16:9"
        }
      ],
      "tags": [
        {
          "type": "song_genre",
          "details": {
            "genreName": "pop",
            "id": "687a1793bb55b0248c4117c3"
          }
        }
      ],
      "metadata": {
        "year": "2023",
        "duration": 210,
        "label": "SonyMusic",
        "language": "english",
        "country": "USA",
        "artists": [

        ]
      }
    },
    {
      "_id": "687a1793bb55b0248c4117ce",
      "type": "song",
      "displayName": "WavesofSilence",
      "multimedia": [
        {
          "mediaType": "image",
          "imageType": "thumbnail",
          "url": "https://image-bucket-nexiantian.s3.ap-south-1.amazonaws.com/actor+photo/kishoreK.png",
          "aspectRatio": "16:9"
        }
      ],
      "tags": [
        {
          "type": "song_genre",
          "details": {
            "genreName": "action",
            "id": "687a1793bb55b0248c4117c4"
          }
        }
      ],
      "metadata": {
        "year": "2024",
        "duration": 228,
        "label": "SaReGaMAIndiaLtd",
        "language": "hindi",
        "country": "India",
        "artists": [

        ]
      }
    },
    {
      "_id": "6890955131f40a8148e58b83",
      "type": "artist",
      "displayName": "Arijit",
      "multimedia": [
        {
          "mediaType": "image",
          "imageType": "thumbnail",
          "url": "https://image-bucket-nexiantian.s3.ap-south-1.amazonaws.com/private/ap-south-1%3A64038f50-13d3-cf2a-9102-fab5a61c8c2e/entertainment_entity/Arijit.jpg",
          "aspectRatio": "1:1"
        },
        {
          "mediaType": "image",
          "imageType": "thumbnail",
          "url": "https://image-bucket-nexiantian.s3.ap-south-1.amazonaws.com/private/ap-south-1%3A64038f50-13d3-cf2a-9102-fab5a61c8c2e/entertainment_entity/Arijit1.jpg",
          "aspectRatio": "3:2"
        }
      ],
      "tags": [
        {
          "type": "songGenre",
          "details": {
            "genreName": "action"
          }
        }
      ],
      "metadata": {
        "artists": [

        ],
        "artistType": "singer",
        "isSuperStar": false,
        "industry": [
          "bollywood"
        ]
      },
      "created_at": "2025-08-04T11:11:13.795Z",
      "updated_at": "2025-08-12T11:14:20.319Z",
      "__v": 0
    },
    {
      "_id": "6891d5920ad9f6069e94d685",
      "type": "artist",
      "displayName": "Arijit",
      "multimedia": [
        {
          "mediaType": "image",
          "imageType": "avatar",
          "url": "https://picsum.photos/seed/picsum/200/200",
          "aspectRatio": "1:1"
        },
        {
          "mediaType": "image",
          "imageType": "thumbnail",
          "url": "https://fastly.picsum.photos/id/382/200/200.jpg?grayscale&hmac=nRBLVgtebwvxOK2CtQnJIkuQiIAiJkXpiSG_GrdIsg4",
          "aspectRatio": "3:4"
        },
        {
          "mediaType": "image",
          "imageType": "banner",
          "url": "https://picsum.photos/id/237/200/200",
          "aspectRatio": "1:2"
        }
      ],
      "tags": [
        {
          "type": "songGenre",
          "details": {
            "genreName": "action"
          }
        }
      ],
      "metadata": {
        "artists": [

        ],
        "artistType": "singer",
        "isSuperStar": false,
        "industry": [
          "bollywood"
        ]
      },
      "created_at": "2025-08-05T09:57:38.029Z",
      "updated_at": "2025-08-05T09:57:38.029Z",
      "__v": 0
    }
  ]
}

const CreateModifyGame = (props) => {

  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;

  const didRunOnce = useRef(false);
  const didRunOnceShows = useRef(false);
  const didRunOnceGetAnchorCat = useRef(false);
  const didRunOnce_GAME_DATA = useRef(false);
  const didRunOnce_SHOWS_DATA = useRef(false);
  const didRunOnce_BACK_GAME_MANAGEMENT = useRef(false);

  const [formGameData, setFormGameData] = useState(null);
  const [showsList, setShowsList] = useState(null);
  const [anchorCatList, setAnchorCatList] = useState(null);
  const [questionActionUsed, setQuestionActionUsed] = useState(null);

  const handleBackToGameManagement = (isReferesh, action, actionData) => {
    //console.log("handleBackToGameManagement 1")
    navigate('/game-management', {
      state: {
        from: 'create-modify-game',
        action: `${action}`,
        actionData: `${actionData}`,
        isReferesh: isReferesh,
        shouldRefresh: isReferesh,
      }
    });
  };

  useEffect(() => {
    if (!didRunOnceShows.current && !props?.SHOWS_LOADING) {
      didRunOnceShows.current = true;
      props?.getShows();
      props?.getAnchorCat();
    }
    return () => {
      console.log("Cleanup CreateModifyGame : ", questionActionUsed);
      if (formGameData !== undefined || formGameData !== null || formGameData?.length > 0) {
        console.log("Cleanup formGameData");
        setFormGameData(null);
        props?.clearGame();
      }
      if (showsList !== undefined || showsList !== null || showsList?.length > 0) {
        console.log("Cleanup showsList");
        setShowsList(null);
        props?.clearShow();
      }
      // if (props?.CREATE_GAME_DATA && questionActionUsed) {
      //     console.log("Cleanup CREATE_GAME_DATA");
      //     props?.clearCreateGame();
      // }
      // else if (props?.UPDATE_GAME_DATA && questionActionUsed) {
      //     console.log("Cleanup UPDATE_GAME_DATA");
      //     props?.clearUpdateGame();
      // }
      // else if (props?.DELETE_GAME_DATA && questionActionUsed) {
      //     console.log("Cleanup DELETE_GAME_DATA");
      //     props?.clearDeleteGame();
      // }
      // setQuestionActionUsed(null);
    }
  }, [])

  useEffect(() => {
    if (!didRunOnce.current && state?.game_data && !props?.GAME_LOADING) {
      didRunOnce.current = true;
      props?.getGame(state?.game_data);
    }
  }, [state?.game_data]);

  useEffect(() => {
    if (!didRunOnce_GAME_DATA.current && props?.GAME_DATA && !formGameData) {
      didRunOnce_GAME_DATA.current = true;
      const game_data = props?.GAME_DATA;
      if (props?.GAME_DATA?.type === GAME_TYPE.FANTASY_LEAGUE_GAME || "fantasyLeague") {
        // const revertedOptions = game_data?.question?.options?.map((opt) => {
        //     return {
        //         ...opt,
        //         displayName: opt?.text,
        //         multimedia: opt?.multimedia ? [opt?.multimedia] : [],
        //         text: undefined,
        //         label: undefined
        //     };
        // });
        // game_data.question.options = revertedOptions;
        //setFormGameData(dummyGameData);
        setFormGameData(props?.GAME_DATA);
      }
      else {
        setFormGameData(props?.GAME_DATA);
      }
    }
    if (!didRunOnce_SHOWS_DATA.current && props?.SHOWS_DATA && !showsList) {
      didRunOnce_SHOWS_DATA.current = true;
      setShowsList(props?.SHOWS_DATA);
      console.log("Shows List set from props:", props?.SHOWS_DATA);
      console.log("showsList set from props:", showsList);
    }
    if (!didRunOnceGetAnchorCat.current && props?.ANCHOR_CAT_DATA && !anchorCatList) {
      didRunOnceGetAnchorCat.current = true;
      setAnchorCatList(props?.ANCHOR_CAT_DATA);
      console.log("Anchor Cat List set from props:", props?.ANCHOR_CAT_DATA);
      console.log("Anchor Cat set from props:", anchorCatList);
    }
  }, [props?.GAME_DATA, props?.SHOWS_DATA, props?.ANCHOR_CAT_DATA]);

  // useEffect(() => {
  //     console.log("condition : 0-1", props?.DELETE_GAME_DATA);
  //     console.log("condition : 0-2", props?.UPDATE_GAME_DATA);
  //     console.log("condition : 0-3", props?.CREATE_GAME_DATA);
  //     console.log("condition : 0-4", didRunOnce_BACK_GAME_MANAGEMENT.current);
  //     if (!didRunOnce_BACK_GAME_MANAGEMENT.current && (props?.CREATE_GAME_DATA || props?.UPDATE_GAME_DATA || props?.DELETE_GAME_DATA) && (questionActionUsed === 'create'||'update'||'delete'||'releaseAnswer')) {
  //         didRunOnce_BACK_GAME_MANAGEMENT.current = true;
  //         console.log("condition : 1");
  //         //props?.clearAlll();
  //         setTimeout(() => {
  //             if (props?.CREATE_GAME_DATA) {
  //                 console.log("CREATE_GAME_DATA : ", props?.CREATE_GAME_DATA);
  //                 handleBackToGameManagement(true, "create", props?.CREATE_GAME_DATA);
  //             }
  //             else if (props?.UPDATE_GAME_DATA) {
  //                 console.log("UPDATE_GAME_DATA : ", props?.UPDATE_GAME_DATA);
  //                 handleBackToGameManagement(true, "update", props?.UPDATE_GAME_DATA);
  //             }
  //             else if (props?.DELETE_GAME_DATA) {
  //                 console.log("DELETE_GAME_DATA : ", props?.DELETE_GAME_DATA);
  //                 handleBackToGameManagement(true, "delete", props?.DELETE_GAME_DATA);
  //             }
  //         }, 1000);

  //     }
  // }, [props?.CREATE_GAME_DATA, props?.UPDATE_GAME_DATA, props?.DELETE_GAME_DATA])


  const isValidPublishAnswer = () => {
    //console.log("Form For isValidForPredicsionBasedResultAnswer : ", formGameData)
    const missingFields = [];

    const questionObj = formGameData?.question;
    const answerObj = questionObj?.answer;
    const answerId = answerObj?.id;

    const gameType = formGameData?.type;

    switch (gameType) {
      case GAME_TYPE.PREDICT_BASED:
        if (formGameData?._id && (answerId === undefined || answerId === null || answerId === '')) {
          missingFields.push('Correct Answer Selection');
        }
        break;

      case GAME_TYPE.FANTASY_LEAGUE_GAME:
        break;

      default:
        missingFields.push('Unsupported Game Type or Type not handled in isValidPublishAnswer');
        break;
    }
    if (missingFields.length > 0) {
      alert(`Please fill the following required fields:\n- ${missingFields.join('\n- ')}`);
      return false;
    }

    return true;
  }

  const isFormValidate = () => {
    //console.log("Form For Validation : ", formGameData)
    const missingFields = [];

    const alterFormGameData = formGameData;

    const gameType = alterFormGameData?.type;    //string
    if (!gameType) missingFields.push('Game Type');
    console.log("Form For gameType : ", gameType)

    if (gameType === GAME_TYPE.FANTASY_LEAGUE_GAME) {
      // const updatedOptions = alterFormGameData.question.options.map((opt, index) => ({
      //     ...opt,
      //     text: opt.displayName,
      //     //label: `${index + 1}`,
      //     multimedia: Array.isArray(opt.multimedia) ? opt.multimedia[0] : opt.multimedia,
      //     //displayName: undefined // remove displayName
      // }));

      // alterFormGameData.question.options = updatedOptions;
      //console.log("updatedOptions1 : ", updatedOptions)

    }
    else if (gameType === GAME_TYPE.SPIN_THE_WHEEL) {
      const updatedOptions = alterFormGameData.question.options.map((opt, index) => ({
        ...opt,
        text: opt.displayName,
        //label: `${index + 1}`,
        index: `${index + 1}`,
        multimedia: Array.isArray(opt.multimedia) ? opt.multimedia[0] : opt.multimedia,
        //displayName: undefined // remove displayName
      }));
      alterFormGameData.question.options = updatedOptions;
      //console.log("updatedOptions2 : ", updatedOptions)
    }
    // if (missingFields.length > 0) {
    //     alert(`Please fill the following required fields:\n- ${missingFields.join('\n- ')}`);
    //     return false;
    // }

    const title = alterFormGameData?.title;
    const subTitle = alterFormGameData?.subTitle;
    const banner = alterFormGameData?.banner;
    const status = alterFormGameData?.status;

    const rules = alterFormGameData?.rules;
    const aboutGame = rules?.aboutGame;
    const sourceOfTruth = rules?.sourceOfTruth;
    const rulesText = rules?.rules;
    const goLiveAt = rules?.goLiveAt;
    const submissionCutOffAt = rules?.submissionCutOffAt;
    const alterCutOffAt = rules?.alterCutOffAt;
    const resultDeclarationAt = rules?.resultDeclarationAt;
    const sourceOfTruthUrl = rules?.sourceOfTruthUrl;
    const termsConditionsUrl = rules?.termsConditionsUrl;

    const anchor = alterFormGameData?.anchor;
    const anchorType = anchor?.type;
    const anchorId = anchor?.id;

    const questionObj = alterFormGameData?.question;
    const questionText = questionObj?.questionText;
    const questionStatus = questionObj?.status;
    const questionMultiMedia = questionObj?.multimedia;
    const options = questionObj?.options;
    const answerObj = questionObj?.answer;
    const answerId = answerObj?.id;

    const forkContestRules = alterFormGameData?.forkContestRules;

    const entityMedia = alterFormGameData?.entityMedia;

    const isValidURL = (url) => {
      const regex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
      return regex.test(url);
    };

    console.log("gameType : ", gameType, " : ", GAME_TYPE.PREDICT_BASED)
    switch (gameType) {
      case GAME_TYPE.PREDICT_BASED:
        break;

      case GAME_TYPE.FANTASY_LEAGUE_GAME:
        if (!status) missingFields.push('Game Status');
        if (!banner) missingFields.push('Game Banner');
        if (!goLiveAt) missingFields.push('Go Live At');
        if (!resultDeclarationAt) missingFields.push('Result Declaration At');
        if (!alterCutOffAt) missingFields.push('Alter Cut Off At');
        if (!submissionCutOffAt) missingFields.push('Submission Cut Off At');
        if (!entityMedia || entityMedia?.length === 0) missingFields.push('Select Entity & their content.');
        // --- Enhanced entityMedia validation ---
        if (!entityMedia || !Array.isArray(entityMedia) || entityMedia.length !== 20) {
          missingFields.push('Select exactly 20 entities for Rap League Game.');
        } else {
          // Check required fields and type counts
          const typeCounts = { song: 0, movie: 0, reel: 0, video: 0, influencers: 0 };
          let missingImage = false, missingDisplayName = false, missingType = false;
          entityMedia.forEach((item, idx) => {
            const ent = item?.entity || {};
            const media = item?.media || {};
            console.log(`Validating entityMedia[${idx}] url :`, !media.url);
            console.log(`Validating entityMedia[${idx}] displayName :`, !ent.displayName);
            if (media) {
              if (!media.url) missingImage = true;
            }
            else {
              if (!ent.image) missingImage = true;
            }
            if (!ent.displayName) missingDisplayName = true;
            if (!ent.type) missingType = true;
            if (ent.type && typeCounts.hasOwnProperty(ent.type)) typeCounts[ent.type]++;
          });
          if (missingImage) missingFields.push('Each entity must have an image.');
          if (missingDisplayName) missingFields.push('Each entity must have a displayName.');
          if (missingType) missingFields.push('Each entity must have a type.');
          // Check for all 5 types and exactly 5 of each
          const requiredTypes = ['song', 'movie', 'reel', 'video', 'influencers'];
          requiredTypes.forEach(type => {
            if (typeCounts[type] !== 4) missingFields.push(`Exactly 4 entities of each category '${type}' required (found ${typeCounts[type] || 0}).`);
          });
        }
        break;

      case GAME_TYPE.SPIN_THE_WHEEL:
        break;

      default:
        missingFields.push('Unsupported Game Type or Type not handled isFormValidate');
        break;
    }
    if (missingFields.length > 0) {
      alert(`Please fill the following required fields:\n- ${missingFields.join('\n- ')}`);
      return { isValid: false, alterFormGameData };
    }

    return { isValid: true, alterFormGameData };
  }

  const handleChange = (path, value) => {
    console.log("handleChange called with path:", path, "and value:", value);
    console.log("handleChange formGameData : ", formGameData);
    if (path === "delete") {
      setQuestionActionUsed("delete");
      props?.deleteGame(formGameData?._id);
      setTimeout(() => {
        handleBackToGameManagement(true, "delete", props?.DELETE_GAME_DATA)
      }, 1000)
    }
    else if (path === "update") {
      const { isValid, alterFormGameData } = isFormValidate();
      console.log("update1 : ", alterFormGameData)
      if (isValid) {
        console.log("update2 : ", alterFormGameData)
        //setQuestionActionUsed("update");
        //const removeGameAnswerResult = removeKeyFromObjectByPath(alterFormGameData, "question.answer");
        props?.updateGame(alterFormGameData);
        setTimeout(() => {
          //console.log("update2 : ")
          handleBackToGameManagement(true, "update", props?.UPDATE_GAME_DATA)
        }, 1000)
      }
    } else if (path === "create") {
      const { isValid, alterFormGameData } = isFormValidate();
      if (isValid) {
        //setQuestionActionUsed("create");
        const payload = alterFormGameData;
        console.log("mediaType : ", !payload?.question?.multimedia?.mediaType)
        if (!payload?.question?.multimedia?.mediaType) {
          const updatedData = {
            ...payload,
            question: {
              ...payload.question,
              multimedia: undefined // or simply delete later
            }
          };

          delete updatedData.question.multimedia;
          console.log("payload : ", updatedData)
          props?.createGame(updatedData);
        }
        else {
          props?.createGame(alterFormGameData);
        }

        setTimeout(() => {
          handleBackToGameManagement(true, "create", props?.CREATE_GAME_DATA)
        }, 1000)
      }
    }
    else if (path === "releaseAnswer") {
      if (formGameData.type === GAME_TYPE.PREDICT_BASED) {
        const { isValid, alterFormGameData } = isFormValidate();
        if (isValid) {
          const isValidForPublishAnswer = isValidPublishAnswer();
          if (isValidForPublishAnswer) {
            console.log("questionId : ", alterFormGameData?.question?._id)
            console.log("answerId : ", alterFormGameData?.question?.answer?.id)
            setQuestionActionUsed("releaseAnswer");
            const requestPayload = { optionId: alterFormGameData?.question?.answer?.id }
            props?.releaseGameAnswer({ questionId: alterFormGameData?.question?._id, requestPayload: requestPayload });
          }
        }
      }
      else if (formGameData.type === GAME_TYPE.FANTASY_LEAGUE_GAME) {
        const { isValid, alterFormGameData } = isFormValidate();
        const answerResult = alterFormGameData?.question?.fantasyResult?.data?.map((item) => ({
          rank: item?.rank === 'N/A' ? -1 : item?.rank, // default value
          optionId: `${item?._id}`,
          entertainmentEntityId: `${item?.entertainmentEntityId ? item?.entertainmentEntityId : '1234'}`
        }))
        const requestPayload = { data: answerResult }
        console.log("request : ", requestPayload)
        setQuestionActionUsed("releaseAnswer");
        props?.releaseGameAnswer({ questionId: alterFormGameData?.question?._id, requestPayload: requestPayload });
      }
    } else {
      updateFormGameData(path, value);
    }
  };

  const removeKeyFromObjectByPath = (obj, path) => {
    const keys = path.split('.');
    const updated = { ...obj };
    let temp = updated;

    for (let i = 0; i < keys.length - 1; i++) {
      const key = keys[i];
      // If path doesn't exist, return the original object
      if (typeof temp[key] !== 'object' || temp[key] === null) {
        return obj;
      }
      temp[key] = Array.isArray(temp[key]) ? [...temp[key]] : { ...temp[key] };
      temp = temp[key];
    }

    const lastKey = keys[keys.length - 1];

    if (Array.isArray(temp) && /^\d+$/.test(lastKey)) {
      temp.splice(parseInt(lastKey), 1);
    } else {
      delete temp[lastKey];
    }

    return updated;
  };

  const updateFormGameData = (path, value) => {
    // const keys = path.split(".");
    // setFormGameData(prev => {
    //     const updated = { ...prev };
    //     let obj = updated;
    //     for (let i = 0; i < keys.length - 1; i++) {
    //         obj = obj[keys[i]];
    //     }
    //     obj[keys[keys.length - 1]] = value;
    //     return updated;
    // });

    const keys = path.split(".");
    setFormGameData(prev => {
      const updated = { ...prev };
      let obj = updated;

      for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];

        // If key doesn't exist OR is not an object/array, create an empty object
        if (typeof obj[key] !== 'object' || obj[key] === null) {
          // If the next key is a number, treat it as an array
          const nextKey = keys[i + 1];
          obj[key] = /^\d+$/.test(nextKey) ? [] : {};
        }

        obj = obj[key];
      }

      const lastKey = keys[keys.length - 1];

      // If updating an array index (like winPositions.0.position)
      if (Array.isArray(obj) && /^\d+$/.test(lastKey)) {
        obj[parseInt(lastKey)] = value;
      } else {
        obj[lastKey] = value;
      }

      return updated;
    });
    console.log("Updated formGameData => ", formGameData);
  }

  return (
    <div style={GameCssStyles.container}>
      <GameContainer formGameData={formGameData} showsList={showsList} setFormGameData={setFormGameData} handleChange={handleChange} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    GAME_LOADING: state?.gameManagement?.game_loading,
    GAME_ERROR: state?.gameManagement?.game_error,
    GAME_DATA: state?.gameManagement?.game_data,
    CREATE_GAME_LOADING: state?.gameManagement?.create_game_loading,
    CREATE_GAME_ERROR: state?.gameManagement?.create_game_error,
    CREATE_GAME_DATA: state?.gameManagement?.create_game_data,
    UPDATE_GAME_LOADING: state?.gameManagement?.update_game_loading,
    UPDATE_GAME_ERROR: state?.gameManagement?.update_game_error,
    UPDATE_GAME_DATA: state?.gameManagement?.update_game_data,
    DELETE_GAME_LOADING: state?.gameManagement?.delete_game_loading,
    DELETE_GAME_ERROR: state?.gameManagement?.delete_game_error,
    DELETE_GAME_DATA: state?.gameManagement?.delete_game_data,
    SHOWS_LOADING: state?.getShows?.show_loading,
    SHOWS_ERROR: state?.getShows?.show_error,
    SHOWS_DATA: state?.getShows?.show_data,
    ANCHOR_CAT_LOADING: state?.getShows?.anchor_categories_loading,
    ANCHOR_CAT_ERROR: state?.getShows?.anchor_categories_error,
    ANCHOR_CAT_DATA: state?.getShows?.anchor_categories_data,
  }
};

const mapDispatchToProps = {
  getShows: getShowRequest,
  getGame: getGameRequest,
  clearGame: () => ({ type: 'CLEAR_A_GAME' }),
  clearShow: () => ({ type: 'CLEAR_SHOW' }),
  clearCreateGame: () => ({ type: 'CLEAR_CREATE_GAME' }),
  clearUpdateGame: () => ({ type: 'CLEAR_UPDATE_GAME' }),
  clearDeleteGame: () => ({ type: 'CLEAR_DELETE_GAME' }),
  deleteGame: deleteGameRequest,
  updateGame: updateGameRequest,
  createGame: createGameRequest,
  releaseGameAnswer: releaseGameAnswerGameRequest,
  getAnchorCat: getAnchorCategoriesRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateModifyGame);
